var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28 16.0241C28 9.38335 22.6274 4 16 4C9.37258 4 4 9.38335 4 16.0241C4 22.0256 8.38823 27 14.125 27.902V19.4998H11.0781V16.0241H14.125V13.375C14.125 10.3615 15.9165 8.6969 18.6576 8.6969C19.9705 8.6969 21.3437 8.93174 21.3437 8.93174V11.8908H19.8306C18.3399 11.8908 17.875 12.8176 17.875 13.7685V16.0241H21.2031L20.6711 19.4998H17.875V27.902C23.6118 27 28 22.0256 28 16.0241Z","fill":"#222222"}));
}

SocialFacebook.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
